"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
var _GemeindeBase = _interopRequireDefault(require("./GemeindeBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Feuerwehr model module.
 * @module model/Feuerwehr
 * @version 0.0.1
 */
class Feuerwehr {
  /**
   * Constructs a new <code>Feuerwehr</code>.
   * @alias module:model/Feuerwehr
   * @param name {String} 
   * @param typ {String} 
   * @param id {Number} 
   */
  constructor(name, typ, id) {
    Feuerwehr.initialize(this, name, typ, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, typ, id) {
    obj['name'] = name;
    obj['typ'] = typ;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>Feuerwehr</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Feuerwehr} obj Optional instance to populate.
   * @return {module:model/Feuerwehr} The populated <code>Feuerwehr</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Feuerwehr();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('typ')) {
        obj['typ'] = _ApiClient.default.convertToType(data['typ'], 'String');
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = _ApiClient.default.convertToType(data['link'], 'String');
      }
      if (data.hasOwnProperty('ortslink')) {
        obj['ortslink'] = _ApiClient.default.convertToType(data['ortslink'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_name')) {
        obj['ortswehrfuehrer_name'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_name'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_email')) {
        obj['ortswehrfuehrer_email'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_email'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_telefon')) {
        obj['ortswehrfuehrer_telefon'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_telefon'], 'String');
      }
      if (data.hasOwnProperty('leiter_name')) {
        obj['leiter_name'] = _ApiClient.default.convertToType(data['leiter_name'], 'String');
      }
      if (data.hasOwnProperty('leiter_email')) {
        obj['leiter_email'] = _ApiClient.default.convertToType(data['leiter_email'], 'String');
      }
      if (data.hasOwnProperty('leiter_telefon')) {
        obj['leiter_telefon'] = _ApiClient.default.convertToType(data['leiter_telefon'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_name')) {
        obj['ortsjugendwart_name'] = _ApiClient.default.convertToType(data['ortsjugendwart_name'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_email')) {
        obj['ortsjugendwart_email'] = _ApiClient.default.convertToType(data['ortsjugendwart_email'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_telefon')) {
        obj['ortsjugendwart_telefon'] = _ApiClient.default.convertToType(data['ortsjugendwart_telefon'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_name')) {
        obj['leiterkinder_name'] = _ApiClient.default.convertToType(data['leiterkinder_name'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_email')) {
        obj['leiterkinder_email'] = _ApiClient.default.convertToType(data['leiterkinder_email'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_telefon')) {
        obj['leiterkinder_telefon'] = _ApiClient.default.convertToType(data['leiterkinder_telefon'], 'String');
      }
      if (data.hasOwnProperty('verwalter')) {
        obj['verwalter'] = _ApiClient.default.convertToType(data['verwalter'], [Object]);
      }
      if (data.hasOwnProperty('gemeinde_id')) {
        obj['gemeinde_id'] = _ApiClient.default.convertToType(data['gemeinde_id'], 'Number');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('dienstplan')) {
        obj['dienstplan'] = _DateiBase.default.constructFromObject(data['dienstplan']);
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('gemeinde')) {
        obj['gemeinde'] = _GemeindeBase.default.constructFromObject(data['gemeinde']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Feuerwehr</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Feuerwehr</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Feuerwehr.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['typ'] && !(typeof data['typ'] === 'string' || data['typ'] instanceof String)) {
      throw new Error("Expected the field `typ` to be a primitive type in the JSON string but got " + data['typ']);
    }
    // ensure the json data is a string
    if (data['link'] && !(typeof data['link'] === 'string' || data['link'] instanceof String)) {
      throw new Error("Expected the field `link` to be a primitive type in the JSON string but got " + data['link']);
    }
    // ensure the json data is a string
    if (data['ortslink'] && !(typeof data['ortslink'] === 'string' || data['ortslink'] instanceof String)) {
      throw new Error("Expected the field `ortslink` to be a primitive type in the JSON string but got " + data['ortslink']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_name'] && !(typeof data['ortswehrfuehrer_name'] === 'string' || data['ortswehrfuehrer_name'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_name` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_name']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_email'] && !(typeof data['ortswehrfuehrer_email'] === 'string' || data['ortswehrfuehrer_email'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_email` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_email']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_telefon'] && !(typeof data['ortswehrfuehrer_telefon'] === 'string' || data['ortswehrfuehrer_telefon'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_telefon` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_telefon']);
    }
    // ensure the json data is a string
    if (data['leiter_name'] && !(typeof data['leiter_name'] === 'string' || data['leiter_name'] instanceof String)) {
      throw new Error("Expected the field `leiter_name` to be a primitive type in the JSON string but got " + data['leiter_name']);
    }
    // ensure the json data is a string
    if (data['leiter_email'] && !(typeof data['leiter_email'] === 'string' || data['leiter_email'] instanceof String)) {
      throw new Error("Expected the field `leiter_email` to be a primitive type in the JSON string but got " + data['leiter_email']);
    }
    // ensure the json data is a string
    if (data['leiter_telefon'] && !(typeof data['leiter_telefon'] === 'string' || data['leiter_telefon'] instanceof String)) {
      throw new Error("Expected the field `leiter_telefon` to be a primitive type in the JSON string but got " + data['leiter_telefon']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_name'] && !(typeof data['ortsjugendwart_name'] === 'string' || data['ortsjugendwart_name'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_name` to be a primitive type in the JSON string but got " + data['ortsjugendwart_name']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_email'] && !(typeof data['ortsjugendwart_email'] === 'string' || data['ortsjugendwart_email'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_email` to be a primitive type in the JSON string but got " + data['ortsjugendwart_email']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_telefon'] && !(typeof data['ortsjugendwart_telefon'] === 'string' || data['ortsjugendwart_telefon'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_telefon` to be a primitive type in the JSON string but got " + data['ortsjugendwart_telefon']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_name'] && !(typeof data['leiterkinder_name'] === 'string' || data['leiterkinder_name'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_name` to be a primitive type in the JSON string but got " + data['leiterkinder_name']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_email'] && !(typeof data['leiterkinder_email'] === 'string' || data['leiterkinder_email'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_email` to be a primitive type in the JSON string but got " + data['leiterkinder_email']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_telefon'] && !(typeof data['leiterkinder_telefon'] === 'string' || data['leiterkinder_telefon'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_telefon` to be a primitive type in the JSON string but got " + data['leiterkinder_telefon']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['verwalter'])) {
      throw new Error("Expected the field `verwalter` to be an array in the JSON data but got " + data['verwalter']);
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // validate the optional field `dienstplan`
    if (data['dienstplan']) {
      // data not null
      _DateiBase.default.validateJSON(data['dienstplan']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // validate the optional field `gemeinde`
    if (data['gemeinde']) {
      // data not null
      _GemeindeBase.default.validateJSON(data['gemeinde']);
    }
    return true;
  }
}
Feuerwehr.RequiredProperties = ["name", "typ", "id"];

/**
 * @member {String} name
 */
Feuerwehr.prototype['name'] = undefined;

/**
 * @member {String} typ
 */
Feuerwehr.prototype['typ'] = undefined;

/**
 * @member {String} link
 */
Feuerwehr.prototype['link'] = undefined;

/**
 * @member {String} ortslink
 */
Feuerwehr.prototype['ortslink'] = undefined;

/**
 * @member {String} ortswehrfuehrer_name
 */
Feuerwehr.prototype['ortswehrfuehrer_name'] = undefined;

/**
 * @member {String} ortswehrfuehrer_email
 */
Feuerwehr.prototype['ortswehrfuehrer_email'] = undefined;

/**
 * @member {String} ortswehrfuehrer_telefon
 */
Feuerwehr.prototype['ortswehrfuehrer_telefon'] = undefined;

/**
 * @member {String} leiter_name
 */
Feuerwehr.prototype['leiter_name'] = undefined;

/**
 * @member {String} leiter_email
 */
Feuerwehr.prototype['leiter_email'] = undefined;

/**
 * @member {String} leiter_telefon
 */
Feuerwehr.prototype['leiter_telefon'] = undefined;

/**
 * @member {String} ortsjugendwart_name
 */
Feuerwehr.prototype['ortsjugendwart_name'] = undefined;

/**
 * @member {String} ortsjugendwart_email
 */
Feuerwehr.prototype['ortsjugendwart_email'] = undefined;

/**
 * @member {String} ortsjugendwart_telefon
 */
Feuerwehr.prototype['ortsjugendwart_telefon'] = undefined;

/**
 * @member {String} leiterkinder_name
 */
Feuerwehr.prototype['leiterkinder_name'] = undefined;

/**
 * @member {String} leiterkinder_email
 */
Feuerwehr.prototype['leiterkinder_email'] = undefined;

/**
 * @member {String} leiterkinder_telefon
 */
Feuerwehr.prototype['leiterkinder_telefon'] = undefined;

/**
 * @member {Array.<Object>} verwalter
 */
Feuerwehr.prototype['verwalter'] = undefined;

/**
 * @member {Number} gemeinde_id
 */
Feuerwehr.prototype['gemeinde_id'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
Feuerwehr.prototype['adresse'] = undefined;

/**
 * @member {module:model/DateiBase} dienstplan
 */
Feuerwehr.prototype['dienstplan'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
Feuerwehr.prototype['bild'] = undefined;

/**
 * @member {Number} id
 */
Feuerwehr.prototype['id'] = undefined;

/**
 * @member {module:model/GemeindeBase} gemeinde
 */
Feuerwehr.prototype['gemeinde'] = undefined;
var _default = exports.default = Feuerwehr;